import { createSelector } from "reselect";

import { GiftPlan } from "rivals/components/pages/User/Subscriptions/types";
import { State as AppState, StateKeys } from "rivals/redux/reducer";
import { createDeepEqualSelector } from "rivals/redux/selector";
import { PLANS } from "rivals/shared/constants";
import { AddOn } from "rivals/shared/interfaces/AddOn";
import { State } from "./reducer";

const selectSubscriptionAddonsState = (state: AppState): State =>
  state[StateKeys.SUBSCRIPTION_ADD_ONS];

export const getSubscriptionEligibleAddons = createSelector(
  selectSubscriptionAddonsState,
  state => state.addOns || []
);

/**
 * Get the list of AddOns a user can subscribe to from the server
 * Fetching at the page component level, because the child components
 * Are shared among various registration and subscription flows.
 * It is the parent's responsibility to pass the approprate add ons
 */
export const selectSubscribableAddOns = createDeepEqualSelector(
  getSubscriptionEligibleAddons,
  (_state: AppState, plan: PLANS | GiftPlan) => plan,
  (addOns, plan) => addOns.filter(addOn => addOn.plan === plan)
);

export const getUserEligibleAddons = createSelector(
  selectSubscriptionAddonsState,
  state => state.userEligibleAddons
);

export const getAddOnPricing = createSelector(
  selectSubscriptionAddonsState,
  state => state.addOnPricing
);

export const getActiveAddOn = createSelector(
  selectSubscriptionAddonsState,
  state => state.activeAddOn
);

export const getChooseYourOwnSchoolAddOns = createSelector(
  selectSubscriptionAddonsState,
  state => state.chooseYourOwnSchoolAddOns
);

export const getError = createSelector(
  selectSubscriptionAddonsState,
  state => state.error
);

export const getSubmitting = createSelector(
  selectSubscriptionAddonsState,
  state => state.submitting
);

export const getAddOnPurchaseSuccess = createSelector(
  selectSubscriptionAddonsState,
  state => state.addOnPurchaseSuccess
);

export const getUpcomingBilling = createSelector(
  selectSubscriptionAddonsState,
  state => state.upcomingBilling
);

export const getUpgradingAddOns = createSelector(
  selectSubscriptionAddonsState,
  state => state.upgradingAddOns
);

export const getRemoveAddOnSuccess = createSelector(
  selectSubscriptionAddonsState,
  state => state.removeAddOnSuccess
);

export const getModalStep = createSelector(
  selectSubscriptionAddonsState,
  state => state.modalStep
);

export const getBundle = createSelector(
  selectSubscriptionAddonsState,
  state => state.bundle
);

export const getUpsellSelectedOption = createSelector(
  selectSubscriptionAddonsState,
  state => state.selectedUpsellStepOption
);

export const getFilteredNonPurchasedChooseAddOns = createSelector(
  getChooseYourOwnSchoolAddOns,
  chooseAddOns => {
    return chooseAddOns && chooseAddOns.filter
      ? chooseAddOns.filter(
          (addOn: AddOn) =>
            !addOn.associatedSubscription ||
            !addOn.associatedSubscription.subscribed
        )
      : [];
  }
);
